<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    TAVI - Profissional Credenciado
  </app-header-dialog>


  <div *ngIf="entityForm">

    <div class="content">

      <mat-form-field appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Cidade</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.city"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 80px;' appearance="outline">
        <mat-label>Estado</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.state"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>CI</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.ci"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>CCV</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.ccv"
          autocomplete="off">
      </mat-form-field>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button (click)="matDialogRef.close(['update', entityForm])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>